import type { BreakpointsOptions } from '@mui/material/styles';

export const breakpoints: BreakpointsOptions = {};
